import { render } from "./PieChart.vue?vue&type=template&id=36f3c548"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
script.render = render

export default script